/**
 * Build Environment Kind
 */
export var EnvironmentKind;
(function (EnvironmentKind) {
    EnvironmentKind["Development"] = "Development";
    EnvironmentKind["Staging"] = "Staging";
    EnvironmentKind["Production"] = "Production";
})(EnvironmentKind || (EnvironmentKind = {}));
//# sourceMappingURL=EnvironmentKind.js.map